/**
 * PracticeScopeToggle — the "Alle Praxen" control itself.
 *
 * ONE implementation, rendered wherever a page can pool practices (Dashboard,
 * Tasks). It writes the shared flag in PracticeContext, so flipping it here is
 * immediately true on the other page: same logic, same markup, same wording,
 * visible in both places.
 *
 * Renders nothing when there is only one practice in scope — with nothing to
 * pool, the choice is not a choice.
 *
 * `onSelect` is the page's own side-effect on a switch (both pages clear their
 * error banner: react-query v3 fires onSuccess only on a real fetch, so a cached
 * mode would otherwise paint its data under the previous mode's banner and never
 * clear it). The note reports a short pool — a practice whose fetch failed — so
 * the view says so instead of quietly under-reporting.
 */
import React from 'react';

const PracticeScopeToggle = ({
  scope,
  onSelect,
  separator = false,
  loadedCount = null,
  scopeCount = null,
}) => {
  const { canAggregate, allPractices, scopeIds, setAllPracticesMode } = scope;
  if (!canAggregate) return null;

  const select = (all) => {
    setAllPracticesMode(all);
    if (onSelect) onSelect(all);
  };

  return (
    <>
      {separator && <span className="dash-head-sep" />}
      <div className="heatmap-mode-toggle" role="tablist" aria-label="Praxis-Umfang">
        <button
          type="button"
          role="tab"
          aria-selected={!allPractices}
          className={`heatmap-mode-pill${!allPractices ? ' is-active' : ''}`}
          onClick={() => select(false)}
        >Diese Praxis</button>
        <button
          type="button"
          role="tab"
          aria-selected={allPractices}
          className={`heatmap-mode-pill${allPractices ? ' is-active' : ''}`}
          onClick={() => select(true)}
        >Alle Praxen ({scopeIds.length})</button>
      </div>

      {allPractices && loadedCount != null && scopeCount != null && loadedCount < scopeCount && (
        <span className="dash-scope-note">
          Daten von {loadedCount} von {scopeCount} Praxen
        </span>
      )}
    </>
  );
};

export default PracticeScopeToggle;
